export const middleFriendLinks = [
  {
    url: 'http://www.xuexifangfa.com/',
    title: '学习方法'
  },
  {
    url: 'http://www.maxen.com.cn',
    title: '中学英语培训'
  },
  {
    url: 'http://yingyu.xdf.cn',
    title: '中学生英语学习'
  },
  {
    url: 'http://zhongxue.xdf.cn/cy/',
    title: '初一英语'
  },
  {
    url: 'http://zhongxue.xdf.cn/cr/',
    title: '初二物理'
  },
  {
    url: 'http://zhongkao.xdf.cn',
    title: '中考网'
  },
  {
    url: 'http://zhongxue.xdf.cn/gy/',
    title: '高一知识点'
  },
  {
    url: 'http://gaokao.xdf.cn',
    title: '高考网'
  },
  {
    url: 'http://souke.xdf.cn/Search?cid=0&ccc=414&gc=0',
    title: '中学英语'
  },
  {
    url: 'http://www.qc99.com',
    title: '范文网'
  },
  {
    url: 'http://e.xdf.cn',
    title: '新东方直播'
  },
  {
    url: 'http://gaokao.tl100.com',
    title: '天利高考网'
  }
]



// WEBPACK FOOTER //
// ./src/api/js/middleschool/friendlinks.js